/* eslint-disable */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { AuthProvider, useAuth } from './context/AuthContext';
import { PermissionProvider } from './context/PermissionContext';
import { ToastProvider } from './context/ToastContext';
import ToastContainer from './components/shared/Toast/ToastContainer';

// Pages
import LoginPage from './pages/auth/LoginPage';
import PlatformPage from './pages/superadmin/PlatformPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import ToolsOverviewPage from './pages/tools/ToolsOverviewPage';
import TimesheetPage from './pages/tools/timesheet/TimesheetPage';
import JournalPage from './pages/tools/journal/JournalPage';
import LeaderPage from './pages/tools/leader/LeaderPage';
import EmployeePage from './pages/tools/employee/EmployeePage';
import VehicleStatusPage from './pages/tools/vehicleStatus/VehicleStatusPage';
import InternalHandoverPage from './pages/tools/internalHandover/InternalHandoverPage';
import RentalPage from './pages/tools/rental/RentalPage';
import FilesPage from './pages/tools/files/FilesPage';
import PhotosPage from './pages/tools/photos/PhotosPage';

// Verwaltung Pages
import VerwaltungOverview from './pages/verwaltung/VerwaltungOverview';
import ProjectsPage from './pages/verwaltung/Projects/ProjectsPage';
import CustomersPage from './pages/verwaltung/customers/Customers';


import './App.css';
// Layouts
import MainLayout from './components/layout/MainLayout';

// Protected Route Wrapper
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) return <div style={{ padding: '20px' }}>Lädt...</div>;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles) {
    const isSuperAdmin = (user.username === 'info@opti-mox.de') || (user.email === 'info@opti-mox.de');

    if (allowedRoles.includes('superadmin') && !isSuperAdmin) {
      return <Navigate to="/" replace />;
    }
    if (allowedRoles.includes('admin') && user.role !== 'admin' && !isSuperAdmin) {
      return <Navigate to="/" replace />;
    }
  }

  return (
    <PermissionProvider user={user}>
      {children}
    </PermissionProvider>
  );
};

const RootRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) return <div style={{ padding: '20px' }}>Lädt...</div>;
  if (!user) return <Navigate to="/login" replace />;

  const isSuperAdmin = (user.username === 'info@opti-mox.de') || (user.email === 'info@opti-mox.de');
  if (isSuperAdmin) return <Navigate to="/superadmin" replace />;

  if (user.role === 'admin') return <Navigate to="/admin" replace />;

  return <Navigate to="/tools" replace />;
};

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          {/* Superadmin - separate layout or no sidebar for now */}
          <Route path="/superadmin/*" element={
            <ProtectedRoute allowedRoles={['superadmin']}>
              <PlatformPage />
            </ProtectedRoute>
          } />

          {/* All other protected routes wrapped in MainLayout */}
          <Route element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/admin/*" element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboardPage />
              </ProtectedRoute>
            } />

            <Route path="/tools" element={<ToolsOverviewPage />} />
            <Route path="/tools/timesheet" element={<TimesheetPage />} />
            <Route path="/tools/journal" element={<JournalPage />} />
            <Route path="/tools/journal/:projectId" element={<JournalPage />} />
            <Route path="/tools/leader" element={<LeaderPage />} />
            <Route path="/tools/internalHandover" element={<InternalHandoverPage />} />
            <Route path="/tools/rental" element={<RentalPage />} />
            <Route path="/tools/files" element={<FilesPage />} />
            <Route path="/tools/photos" element={<PhotosPage />} />

            {/* New Verwaltung Routes */}
            <Route path="/verwaltung" element={<VerwaltungOverview />} />
            <Route path="/verwaltung/mitarbeiter" element={<EmployeePage />} />
            <Route path="/verwaltung/fuhrpark" element={<VehicleStatusPage />} />
            <Route path="/verwaltung/projekte" element={<ProjectsPage />} />
            <Route path="/verwaltung/kunden" element={<CustomersPage />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ToastContainer />
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;